/**
 * Initializes the event handler to allow the "Change location" call to action to
 * open the search box & focus on the location input.
 *
 * @param {Function} openSearchFunc Function that will open the search box.
 * @param {string} locationQuerySelector jQuery selector for the Location input box.
 */
export function initLocationCTAButton(openSearchFunc, locationQuerySelector) {
  // Handle case when a search is performed with no explicit location &
  // displays a CTA to "Change location"
  $(document).on('click', '[data-change-location]', () => {
    openSearchFunc();

    const locationInput = $(locationQuerySelector);
    locationInput.val('');
    locationInput.trigger('focus');
  });
}
